import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TapPlatform' + '/dataTable');
export const setColumnConfig = actionCreator('STORE_COLUMN_CONFIG');
export const setSelected = actionCreator('STORE_DATA_TABLE_SELECTED');
export const setSelectedAll = actionCreator('STORE_DATA_TABLE_SELECTED_ALL');
export const resetDataTableState = actionCreator('RESET_DATA_TABLE_STATE');
//# sourceMappingURL=datatable.actions.js.map